import {mobileActive} from './handle-mobile';
import eventBus from "./event-bus";

const mainNavigation = $('#is-main-navigation');

const isTouchDevice = () => {
    return window.matchMedia("(pointer: coarse)").matches
}

function mainMenu() {

    if (!mobileActive.status) {

        const openMegaMenu = $('.is-open-megamenu');
        const megaMenu = $('.is-nav-list.container');
        const offcanvasMenu = $('.is-offcanvas-menu');
        const navItem = $('.is-nav-item');
        const navItemFirst = megaMenu.children('.is-nav-item');
        const navItemLast = megaMenu.find('.is-nav-item.is-nav-item--last');
        const body = $('body');
        const mainNavSlot = $('#mainNavSlot');
        const backdrop = 'is-backdrop';
        const active = 'active';
        const dropdownMenu = $('#dropdownMenu');
        const triggerMegaMenu = dropdownMenu.find('a');

        let menuActive = false;

        function countMenuNodes() {
            return megaMenu.data('menu-depth') - 1;
        }

        function getMenuWidth() {
            return megaMenu.width();
        }

        function getNavItemWidth() {
            return navItemFirst.width();
        }

        function getWindowWidth() {
            return $(window).width();
        }

        function calcLastLiWidth() {
            return getMenuWidth() - countMenuNodes() * getNavItemWidth();
        }

        function setLastUlWidth() {
            navItemLast.css('width', calcLastLiWidth())
        }

        function setBackdrop() {
            body.addClass(backdrop);
        }

        function removeBackdrop() {
            body.removeClass(backdrop);
        }

        function openMenu(e, id) {
            $(id ? '#' + id : e.target).closest(navItem).find(megaMenu).addClass(active);
        }

        function closeOtherMenu(e) {
            const elNavItem = $(e.target).closest(navItem);
            const elNavMenu = elNavItem.closest('.is-offcanvas-menu');
            const elNavItemOther = elNavMenu.children().not(elNavItem);
            const elNavItemLinkOther = elNavItemOther.find('.is-open-megamenu');
            elNavItemLinkOther.removeClass('active');
            elNavItemOther.find(megaMenu).removeClass('active');
        }

        function closeAllMenus() {
            megaMenu.removeClass(active);
        }

        function closeDropDown(el) {
            el.find('.dropdown-toggle').removeClass('show').attr('aria-expanded', false);
            el.find('.dropdown-menu').removeClass('show').removeAttr('style');
        }

        function enableMenu(e, id) {

            id ? $('#' + id).addClass('active') : $(e.target).parent('a').addClass('active');

            menuActive = true;

            setBackdrop();
            openMenu(e, id);
            getMenuWidth();
            getWindowWidth();
        }

        triggerMegaMenu.on('click', function (e) {
            if ($(this).hasClass('trigger-mega-menu')) {
                const id = $(this).data('id')
                enableMenu(e, id);
            }
            closeDropDown($('#dropdownMenuWrap'));

        })

        function disableMenu(e) {
            menuActive = false;
            openMegaMenu.removeClass('active');
            removeBackdrop();
            closeAllMenus();
            mainNavSlot.addClass('visually-hidden');
            if (typeof e !== 'undefined') {
                e.stopPropagation();
            }
        }

        openMegaMenu.on('click', function (e) {
            closeOtherMenu(e)
            enableMenu(e);
            setLastUlWidth();
            e.stopPropagation();
            slotActions();
        });

        body.on('click', function (e) {
            if (menuActive) {
                disableMenu(e)
            }
        });

        mainNavigation.on('click', function (e) {
            e.stopPropagation();
        })

        setLastUlWidth();

        let doIt;
        window.onresize = function () {
            clearTimeout(doIt);
            doIt = setTimeout(function () {
                setLastUlWidth();
            }, 250);
        };

        function slotActions() {

            mainNavSlot.removeClass('visually-hidden');

            calcMenuSlot(2, 300);

            const menuDataItem = $('.offcanvas-level-1').find('.is-nav-item-js-event');

            menuDataItem.on('mouseover', function (e) {
                let level = $(this).closest('.is-nav-item').data('level');
                const width = $(this).closest('.is-nav-item').width();
                const checkSibling = $(this).closest('.is-nav-item-link').siblings('ul').length > 0;
                if (typeof level !== 'undefined') {
                    if (checkSibling) {
                        level += 1;
                    }
                    calcMenuSlot(level, width);
                }
                e.stopPropagation();
            })

            offcanvasMenu.find('ul.is-nav-list').on('mouseover', function (e) {
                let level = $(this).data('level');
                if (typeof level !== 'undefined') {
                    calcMenuSlot(level, 300);
                }
                e.stopPropagation();
            })

            offcanvasMenu.find('ul.is-nav-list').on('mouseout', function (e) {
                let level = $(this).data('level');
                if (typeof level === 'undefined') {
                    calcMenuSlot(2, 300);
                }
                e.stopPropagation();
            })

            $('.' + backdrop).on('mouseover', function (e) {
                calcMenuSlot(2, 300);
                e.stopPropagation();
            })

        }

        function calcMenuSlot(level, width) {
            const containerWidth = $('.is-offcanvas--main-nav').width();
            const size = (containerWidth - 50) - ((level) * width);
            setMainSlotSize(size);
            hideProductListItems(size);
        }

        function setMainSlotSize(size) {
            mainNavSlot.css('width', size)
        }

        function productListItemSize() {
            return mainNavSlot.children('.is-card-product-wrap').width()
        }

        function countListItems() {
            return mainNavSlot.children('.is-card-product-wrap').length
        }

        function hideProductListItems(size) {
            let count = Math.floor(size / productListItemSize())
            $(`.is-nav-slot .is-card-product-wrap`).addClass('visually-hidden');
            mainNavSlot.children('.is-card-product-wrap').each(function (index) {
                if (index < count) {
                    $(`.is-nav-slot .is-card-product-wrap:eq(${index - 1})`).removeClass('visually-hidden')
                }
            })
        }

        eventBus.on('search-focused', function (e) {
            disableMenu();
        });

    }

    $('#is-main-navigation').find('[data-url]').on('click', function (e) {
        // when offcanvas is hidden, we don't want to open the link here!
        if($('#offcanvasMenu').is(':not([aria-modal=true])') && $(e.target).closest('a').data('open-desktop') === 0) {
            return;
        }

        let linkTo = $(e.target).closest('a').data('url');
        let linkTarget = $(e.target).closest('a').data('target');

        if(isTouchDevice() && $(e.target).parent('a').hasClass('is-nav-item-link-has-children')) {
            if ($(e.target).parent('a').hasClass('on')) {
                window.open(linkTo, linkTarget);
                return;
            }
            $(e.target).removeClass('on');
            $(e.target).parent('a').addClass('on');

        } else {
            window.open(linkTo, linkTarget);
        }

    })



}

mainMenu();

eventBus.on('init-main-menu', function () {
    mainMenu();
    $('body').removeClass('is-backdrop');
});


